import type React from 'react';

import { useUserForm } from '@/hooks/registration/useUserForm';
import UsernameFormView from '@/components/organism/Registration/UserForm/UserForm.view';

export function UsernameForm(): React.JSX.Element {
  const { state, handlers } = useUserForm();

  return (
    <UsernameFormView
      title="Register your new user account"
      subtitle="Find your one-time password (OTP) in your Welcome email."
      emailLabel="Email Address"
      setupCodeLabel="One-time Passcode (OTP)"
      setupCodeHint="Check your welcome email for the OTP"
      email={state.email}
      setupCode={state.setupCode}
      emailError={state.emailError}
      setupCodeError={state.setupCodeError}
      globalError={state.globalError}
      isSubmitting={state.isSubmitting}
      isResending={state.isResending}
      isContinueDisabled={state.isContinueDisabled}
      isResendDisabled={state.isResendDisabled}
      onEmailChange={handlers.handleEmailChange}
      onSetupCodeChange={handlers.handleSetupCodeChange}
      onSubmit={handlers.handleSubmit}
      onResendOtp={handlers.handleResendOtp}
    />
  );
}

UsernameForm.displayName = 'UsernameForm';

export default UsernameForm;
